import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Bell from "./Bell"

const Component = ({ microcopy }) => (
  <StaticQuery
    query={query}
    render={({ entries }) => (
      <Bell microcopy={microcopy} entries={entries.nodes} />
    )}
  />
)

const query = graphql`
  query {
    entries: allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "changelog" }, id: { ne: "changelog" } }
      }
      sort: {frontmatter: {published_at: DESC}},
      limit: 3
    ) {
      nodes {
        id
        titleAst
        path
        frontmatter {
          published_at
          is_new_feature
          is_impactful
          applies_to
        }
      }
    }
  }
`

export default Component
